import { T } from '../domaine/libelles'
import { ouvrirSession } from '../noyau/session'
import { el, vider } from '../ui/dom'

/*
  Premier lancement — saisie du code de saison.

  Aucun compte, aucun email, aucun mot de passe. Un code partagé, saisi une
  fois sur ce téléphone, échangé contre un jeton opaque. Le prénom est libre
  et facultatif : il sert uniquement à identifier le binôme sur le terrain.
*/

export function monterCodeSaison(hote: HTMLElement, surSucces: () => void): () => void {
  vider(hote)

  const code = el('input', {
    type: 'text',
    class: 'champ champ--code',
    autocapitalize: 'characters',
    autocomplete: 'off',
    autocorrect: 'off',
    spellcheck: 'false',
    placeholder: 'KW27-SALINES',
    'aria-label': T.codeTitre,
  }) as HTMLInputElement

  const prenom = el('input', {
    type: 'text',
    class: 'champ',
    autocomplete: 'given-name',
    'aria-label': T.codePrenom,
  }) as HTMLInputElement

  const message = el('p', { class: 'message', role: 'alert' })

  const valider = el('button', {
    type: 'button',
    class: 'bouton-plein bouton-plein--grand',
    text: T.codeValider,
  })

  valider.addEventListener('click', () => {
    if (!code.value.trim()) return
    valider.disabled = true
    message.textContent = ''

    void ouvrirSession(code.value, prenom.value || null).then((resultat) => {
      valider.disabled = false
      if (resultat.ok) {
        surSucces()
        return
      }
      if (resultat.motif === 'code_invalide') message.textContent = T.codeInvalide
      else if (resultat.motif === 'trop_de_tentatives') {
        const minutes = Math.ceil(resultat.reessayerDans / 60)
        message.textContent = `${T.codeTropDeTentatives} ${minutes} min.`
      } else message.textContent = T.codeReseau
    })
  })

  code.addEventListener('keydown', (e) => {
    if ((e as KeyboardEvent).key === 'Enter') valider.click()
  })

  hote.append(
    el('section', { class: 'accueil' }, [
      el('h1', { class: 'accueil__titre', text: T.codeTitre }),
      el('p', { class: 'accueil__aide', text: T.codeAide }),

      el('div', { class: 'bloc-champ' }, [
        el('label', { class: 'champ__label', text: T.codeTitre.toUpperCase() }),
        code,
      ]),

      el('div', { class: 'bloc-champ' }, [
        el('label', { class: 'champ__label', text: T.codePrenom.toUpperCase() }),
        prenom,
        el('p', { class: 'champ__aide', text: T.codePrenomAide }),
      ]),

      message,
      valider,
    ]),
  )

  code.focus()

  return () => vider(hote)
}
